import api from './api';

export const contactService = {
  getContacts: async () => {
    const response = await api.get('/contacts');
    return response.data;
  },

  updateContacts: async (contacts) => {
    const response = await api.put('/contacts', contacts);
    return response.data;
  },
};